'use client';
import { forwardRef } from 'react';
import { TopContainer } from '../../styles';
import { FixedSkeletonLoader, SkeletonRow } from './styles';

const CARDS_COUNT = 3;

export const TopEventsSkeleton = forwardRef<
  HTMLDivElement,
  { $isMobileOnly?: boolean }
>(function TopEventsSkeleton(props, ref) {
  return (
    <TopContainer ref={ref} {...props}>
      <SkeletonRow>
        {[...Array(CARDS_COUNT)].map((_, index) => (
          <FixedSkeletonLoader key={index} />
        ))}
      </SkeletonRow>
    </TopContainer>
  );
});
